import React, { useEffect } from "react";
import { FormField } from "../../../components/molecules/FormField/FormField";
import { Button } from "../../../components/atoms/Button/Button";
import {
  WhatsappGroupStateInterface,
  AddWhatsappGroupInterface,
  WhatsappGroupInterface,
} from "../../../features/admin/manageWhatsappGroups/domain";
import styles from "./ManageWhatsappGroupForm.module.css";

interface ManageWhatsappGroupFormProps {
  manageWhatsappGroupsState: WhatsappGroupStateInterface;
  setWhatsappGroupForm: (form: AddWhatsappGroupInterface) => void;
  setIsFormVisible: React.Dispatch<React.SetStateAction<boolean>>;
  handleAddGroup: (e: React.FormEvent<HTMLFormElement>) => void;
  action: "add" | "update";
}

export const ManageWhatsappGroupForm: React.FC<
  ManageWhatsappGroupFormProps
> = ({
  manageWhatsappGroupsState,
  setWhatsappGroupForm,
  setIsFormVisible,
  handleAddGroup,
  action,
}) => {
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <form onSubmit={handleAddGroup} className={styles.form}>
          <h2 className="text-2xl font-bold mb-7 mt-7 text-center">
            {action === "add" ? "Agregar Nuevo Grupo" : "Actualizar Grupo"}
          </h2>
          <FormField
            id="groupName"
            label="Nombre del Grupo"
            type="text"
            value={manageWhatsappGroupsState.whatsappGroupForm.name}
            onChange={(e) =>
              setWhatsappGroupForm({
                ...manageWhatsappGroupsState.whatsappGroupForm,
                name: e.target.value,
              })
            }
            placeholder="Ej: Grupo de Apoyo Zona 1"
          />
          <FormField
            id="groupLink"
            label="Enlace de Invitación"
            type="url"
            value={manageWhatsappGroupsState.whatsappGroupForm.link}
            onChange={(e) =>
              setWhatsappGroupForm({
                ...manageWhatsappGroupsState.whatsappGroupForm,
                link: e.target.value,
              })
            }
            placeholder="https://chat.whatsapp.com/..."
          />
          <FormField
            label="Estado"
            id="status"
            type="checkbox"
            name="status"
            checked={
              manageWhatsappGroupsState.whatsappGroupForm.status || false
            }
            onChange={(e) =>
              setWhatsappGroupForm({
                ...manageWhatsappGroupsState.whatsappGroupForm,
                status: e.target.checked,
              })
            }
          />
          <div className={styles.formActions}>
            <Button
              type="button"
              onClick={() => setIsFormVisible(false)}
              className={styles.cancelButton}
            >
              Cancelar
            </Button>
            <Button color="accent" type="submit" disabled={manageWhatsappGroupsState.loading}>
              {manageWhatsappGroupsState.loading
                ? "Agregando..."
                : "Agregar Grupo"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
